<template>
    <div>

    </div>
</template>

<script>
    export default {
        created(){
            // console.log('aaaa')
            this.$Progress.start()
            this.$store.dispatch('authentication/signOut')
                .then(() => {
                    // this.$router.push({name: 'login'})
                    // console.log('loged out')
                    this.$Progress.finish()
                })
                .catch(error => {
                    if(error.response.status == 401 || error.response.status == 419){
                        this.$store.dispatch("authentication/cencelAuthen")
                    }
                    this.$Progress.fail()
                })
        }
    }
</script>

<style lang="scss" scoped>

</style>